var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-card my-1",class:_vm.statusClass},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"dot me-2"}),_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.borrowStatus))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }